var PropertyImages = function() {
  var $ = require('jquery');

  $(".js-property-image").click(function(){
    var $this = $(this);
    var NewImage = $this.data("id");
    $(".js-main-image").attr('src', NewImage);
  });
}
module.exports = PropertyImages;